import React, {Component} from 'react'
import PropsTypes from 'prop-types'
import {ModalBody, ModalHeader} from "reactstrap"
import {_updateWorkerData} from "../../../../../services/apis/WorkerServices"

class UpdateWorkerDataForm extends Component {
    state = {
        modalData: this.props.modalData,
        isUpdating: false,
    }


    _handleChangeTextForm = field => e => {
        const {value} = e.target
        this.setState(({modalData}) => ({
            modalData: {
                ...modalData,
                [field]: value
            }
        }))
    }

    _handleSubmit = (e) => {
        e.preventDefault()

        const {modalData} = this.state
        this.setState({
            isUpdating: true
        })

        _updateWorkerData(modalData._id, modalData)
            .then(result => {
                if (result.success) {
                    this.props.onCloseModal()
                    this.props.onUpdateListWorker(modalData)
                }
            })
            .catch(err => {
                console.log(err)
            })

    }

    render() {
        const {username, password, proxy, country, note, secretCode} = this.state.modalData
        const {isUpdating} = this.state

        return (
            <div>
                <ModalHeader toggle={this.toggle}>Edit </ModalHeader>
                <ModalBody>
                    <form onSubmit={this._handleSubmit}>
                        <div className="form-group">
                            <div className='row'>
                                <div className='col-3'>
                                    <label>Username</label>
                                </div>
                                <div className='col-9'>
                                    <input
                                        className='form-control'
                                        value={username}
                                        placeholder='username'
                                        onChange={this._handleChangeTextForm('username')}
                                    />
                                </div>
                            </div>


                        </div>
                        <div className="form-group">
                            <div className='row'>
                                <div className='col-3'>
                                    <label>Password</label>
                                </div>
                                <div className='col-9'>
                                    <input
                                        className='form-control'
                                        value={password}
                                        placeholder='password'
                                        onChange={this._handleChangeTextForm('password')}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="form-group">
                            <div className='row'>
                                <div className='col-3'>
                                    <label>Secret code</label>
                                </div>
                                <div className='col-9'>
                                    <input
                                        className='form-control'
                                        value={secretCode}
                                        placeholder='Secret Code'
                                        onChange={this._handleChangeTextForm('secretCode')}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="form-group">
                            <div className='row'>
                                <div className='col-3'>
                                    <label>Proxy</label>
                                </div>
                                <div className='col-9'>
                                    <input
                                        className='form-control'
                                        value={proxy}
                                        placeholder='proxy'
                                        onChange={this._handleChangeTextForm('proxy')}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className="form-group">
                            <div className='row'>
                                <div className='col-3'>
                                    <label>Country</label>
                                </div>
                                <div className='col-9'>
                                    <input
                                        className='form-control'
                                        value={country}
                                        placeholder='Country'
                                        onChange={this._handleChangeTextForm('country')}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className="form-group">
                            <div className='row'>
                                <div className='col-3'>
                                    <label>Note</label>
                                </div>
                                <div className='col-9'>
                                    <input
                                        className='form-control'
                                        value={note}
                                        placeholder='Note'
                                        onChange={this._handleChangeTextForm('note')}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className="form-group">
                            <button className="btn btn-success" type='submit' disabled={isUpdating}>Update</button>
                        </div>
                    </form>
                </ModalBody>
            </div>
        )
    }
}

UpdateWorkerDataForm.propsTypes = {
    onCloseModal: PropsTypes.func.isRequired,
    onUpdateListWorker: PropsTypes.func.isRequired,
    onToggleModal: PropsTypes.func.isRequired,
    modalData: PropsTypes.object.isRequired,
    onChangeModalData: PropsTypes.func.isRequired,
}

export default UpdateWorkerDataForm



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/UpdateWorkerDataForm.js